<template>
  <div class="d-flex align-center">
    <!-- <v-tooltip top v-if="!params.data.da_id && params.data.status !== 'Completed' && params.data.status !== 'Cancelled' && params.data.stage !== 'Drop'">
      <template #activator="{ on, attrs }">
        <v-btn icon small color="success" class="mr-2" v-on="on" v-bind="attrs" @click="confirmDA">
          <v-icon>mdi-check-circle</v-icon>
        </v-btn>
      </template>
      <span>Confirm DA</span>
    </v-tooltip> -->


    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon v-if="
          !params.context.parentComponent.permissions ||
          params.context.parentComponent.permissions.view
        " color="primary" class="ml-1" v-on="on" v-bind="attrs" @click="viewDetails">
          mdi-eye
        </v-icon>
      </template>
      <span>View Details</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    confirmDA() {
      this.params.context.parentComponent.openConfirmDA(this.params.data.id);
    },
    viewDetails() {
      this.params.context.parentComponent.viewDetails(this.params.data.id);
    },
  },
};
</script>
